<div class="modal-container account-settings-modal">
  <div class="modal-header">
    <input ngbAutofocus class="no-size" />
    <h5 class="modal-title">Account Settings</h5>
    <grid-ui-icon
      class="close-icon"
      aria-label="Close"
      data-hook="settingsCloseButton"
      (click)="close(null)"
      ngbTooltip="Close window"
      name="cross"
      data-testid="icon-close-modal"
    >
    </grid-ui-icon>
  </div>
  <div class="modal-body">
    <div class="mc-actions-header">
      @if (userOrganisation$ | async; as userOrganisation) {
        <div class="mc-actions-header__account-name">
          <h2
            data-hook="subscription-nav-account"
            class="lh-22 fw-bold mc-actions-header__account-organisation"
            [ngbTooltip]="userOrganisation.organisation"
          >
            {{ userOrganisation.organisation }}
          </h2>
        </div>
      } @else {
        <grid-ui-loading class="subscription_loading" message=""></grid-ui-loading>
      }
      <h2 class="me-auto lh-22 mc-actions-header__account-settings">Account Settings</h2>
      <button
        type="button"
        class="btn mc-btn-secondary save-btn ms-auto"
        [disabled]="savingStatus.status === SavingRequestStatus.saving"
        data-hook="settingsEditPasswordButton"
        (click)="close(AccountSettingsModalResolvedValues.CHANGE_PASSWORD)"
        data-testid="btn-edit-pswrd"
      >
        Edit Password
      </button>
    </div>
    @if (form) {
      <form class="modal-body-main-content" [formGroup]="form">
        <div class="mc-form-container">
          <div class="mc-form-group-container">
            <div class="form-group">
              <label [for]="controlNames.FIRST_NAME">First name(s)</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="controlNames.FIRST_NAME"
                [id]="controlNames.FIRST_NAME"
                placeholder="Enter first name(s)"
                data-hook="settingsFirstName"
                [ngClass]="{ invalid: isErrorInFormValue(controlNames.FIRST_NAME) }"
                data-testid="input-first-name"
              />
              @if (isErrorInFormValue(controlNames.FIRST_NAME)) {
                <div class="validation-error">
                  @if (form!.get(controlNames.FIRST_NAME)?.hasError('required')) {
                    <span data-hook="settingsFirstNameRequired"> First name is required </span>
                  }
                  @for (errorMessage of parsedSavingError.first_name; track errorMessage; let i = $index) {
                    <span [attr.data-hook]="'settingsFirstNameValidation-' + i">
                      {{ errorMessage }}
                    </span>
                  }
                </div>
              }
            </div>
            <div class="form-group">
              <label [for]="controlNames.LAST_NAME">Last name</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="controlNames.LAST_NAME"
                [id]="controlNames.LAST_NAME"
                placeholder="Enter last name"
                data-hook="settingsLastName"
                [ngClass]="{ invalid: isErrorInFormValue(controlNames.LAST_NAME) }"
                data-testid="input-last-name"
              />
              @if (isErrorInFormValue(controlNames.LAST_NAME)) {
                <div class="validation-error">
                  @if (form!.get(controlNames.LAST_NAME)?.hasError('required')) {
                    <span data-hook="settingsLastNameRequired"> Last name is required </span>
                  }
                  @for (errorMessage of parsedSavingError.last_name; track errorMessage; let i = $index) {
                    <span [attr.data-hook]="'settingsLastNameValidation-' + i">
                      {{ errorMessage }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
          <div class="mc-form-group-container">
            <div class="form-group">
              <label>Corporate email address</label>
              <div class="email-container">
                <div
                  class="email-field"
                  ngbTooltip="Contact support@maplecroft.com to request a change to your email address"
                  data-hook="settingsEmail"
                >
                  {{ currentAccountSettings.email }}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label [for]="controlNames.PHONE">Corporate phone number</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="controlNames.PHONE"
                [id]="controlNames.PHONE"
                placeholder="Enter phone number"
                data-hook="settingsPhone"
                [ngClass]="{ invalid: isErrorInFormValue(controlNames.PHONE) }"
                data-testid="input-phone-no"
              />
              @if (isErrorInFormValue(controlNames.PHONE)) {
                <div class="validation-error">
                  @for (errorMessage of parsedSavingError.phone_number; track errorMessage; let i = $index) {
                    <span [attr.data-hook]="'settingsPhoneValidation-' + i">
                      {{ errorMessage }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
          <div class="mc-form-group-container">
            <div class="form-group">
              <label [for]="controlNames.CITY">City</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="controlNames.CITY"
                [id]="controlNames.CITY"
                placeholder="Enter city"
                data-hook="settingsCity"
                [ngClass]="{ invalid: isErrorInFormValue(controlNames.CITY) }"
                data-testid="input-city"
              />
              @if (isErrorInFormValue(controlNames.CITY)) {
                <div class="validation-error">
                  @for (errorMessage of parsedSavingError.city; track errorMessage; let i = $index) {
                    <span [attr.data-hook]="'settingsCityValidation-' + i">
                      {{ errorMessage }}
                    </span>
                  }
                </div>
              }
            </div>
            <div class="form-group">
              <label [for]="controlNames.COUNTRY">Country</label>
              <grid-ui-quick-search-dropdown
                [countHeaderLabel]="'Countries'"
                [dropdownMessage]="selectedCountry()?.id ? selectedCountry().name : 'Select country'"
                [dropdownId]="controlNames.COUNTRY"
                [searchable]="true"
                [allowNullItem]="true"
                [dropdownData]="countryData()"
                [placeholder]="'Search countries'"
                [disabled]="!countries()?.content?.items?.length || savingStatus.status === SavingRequestStatus.saving"
                [invalid]="getBackendErrors(controlNames.COUNTRY).length > 0"
                (hintChange)="countriesSearchTerm.set($event)"
                (resultSelected)="handleCountryDropdownAction($event)"
                data-testid="drpdwn-country"
              >
                <grid-ui-no-matching-results [message]="'No country matches your search term'"></grid-ui-no-matching-results>
              </grid-ui-quick-search-dropdown>
              @if (form!.get(controlNames.COUNTRY)?.touched || form!.get(controlNames.COUNTRY)?.dirty) {
                <div class="validation-error">
                  @for (errorMessage of parsedSavingError.country; track errorMessage; let i = $index) {
                    <span [attr.data-hook]="'settingsCountryValidation-' + i">
                      {{ errorMessage }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
          <div class="mc-form-group-container">
            <div class="form-group">
              <label [for]="controlNames.JOB_TITLE">Job title</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="controlNames.JOB_TITLE"
                [id]="controlNames.JOB_TITLE"
                placeholder="Enter job title"
                data-hook="settingsJobTitle"
                [ngClass]="{ invalid: isErrorInFormValue(controlNames.JOB_TITLE) }"
                data-testid="input-job-title"
              />
              @if (isErrorInFormValue(controlNames.JOB_TITLE)) {
                <div class="validation-error">
                  @for (errorMessage of parsedSavingError.job_title; track errorMessage; let i = $index) {
                    <span [attr.data-hook]="'settingsJobTitleValidation-' + i">
                      {{ errorMessage }}
                    </span>
                  }
                </div>
              }
            </div>
            <div class="form-group">
              <label [for]="controlNames.DEPARTMENT">Department</label>
              <input
                type="text"
                class="form-control"
                [formControlName]="controlNames.DEPARTMENT"
                [id]="controlNames.DEPARTMENT"
                placeholder="Enter department"
                data-hook="settingsDepartment"
                [ngClass]="{ invalid: isErrorInFormValue(controlNames.DEPARTMENT) }"
                data-testid="input-department"
              />
              @if (isErrorInFormValue(controlNames.DEPARTMENT)) {
                <div class="validation-error">
                  @for (errorMessage of parsedSavingError.department; track errorMessage; let i = $index) {
                    <span [attr.data-hook]="'settingsDepartmentValidation-' + i">
                      {{ errorMessage }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </form>
    }

    @if (savingStatus.status === SavingRequestStatus.error && parsedSavingError.general !== undefined) {
      <div class="mc-backend-error">
        <grid-ui-unexpected-error-status [errorStatus]="parsedSavingError.general!"> </grid-ui-unexpected-error-status>
      </div>
    }
  </div>
  <div class="modal-footer mc-actions-footer">
    <span class="mc-info-links">
      <a
        class="mc-info-link"
        [href]="emailPreferenceUrl"
        target="_blank"
        rel="noreferrer noopener"
        data-hook="settingsEmailPreferences"
        data-testid="link-email-preference"
      >
        Manage email preferences
      </a>
      <a
        class="mc-info-link"
        [routerLink]="['/privacy-center/cookie-policy']"
        (click)="close(null)"
        data-hook="cookiePrivacyCenterLink"
        data-testid="link-cookie-preference"
      >
        Cookie Preferences
      </a>
      <a
        class="mc-info-link"
        href="https://www.maplecroft.com/privacy-notice/"
        target="_blank"
        rel="noopener noreferrer"
        [hidden]="savingStatus.status === SavingRequestStatus.saving || savingStatus.status === SavingRequestStatus.saved"
        data-hook="settingsPrivacyLink"
        data-testid="link-privacy-notice"
      >
        Privacy notice
      </a>

      <a
        class="mc-info-link"
        href="https://www.maplecroft.com/conditions-of-use/"
        target="_blank"
        rel="noopener noreferrer"
        [hidden]="savingStatus.status === SavingRequestStatus.saving || savingStatus.status === SavingRequestStatus.saved"
        data-hook="settingsTandCLink"
        data-testid="link-condition-of-use"
      >
        Conditions of use
      </a>
    </span>
    <button
      type="button"
      class="btn mc-btn-primary save-btn"
      [disabled]="getSubmitDisabled()"
      data-hook="settingsSubmitButton"
      (click)="saveSettings()"
      data-testid="btn-done"
    >
      Done
      @if (savingStatus.status === SavingRequestStatus.saving) {
        <grid-ui-loading class="mc-saving" data-hook="settingsSavingIcon" [message]="''" class="loading-icon"></grid-ui-loading>
      }
    </button>
  </div>
</div>
